import React from "react";
import slugifyAnchor from "../helpers/slugifyAnchor";
import TableOfContents from "./TableOfContents";

const TableOfContentsBlock = ({ block }) => {
    const sections = block?.sections || [];
    const blockId = slugifyAnchor(block?.blockId) || "table-of-contents";
    const items = sections
        .filter((section) => section?.header)
        .map((section, sectionIndex) => ({
            id: `${blockId}-section-${sectionIndex + 1}`,
            label: section.header,
            children: (section.subsections || [])
                .filter((subtitle) => subtitle?.header && subtitle?.anchorId)
                .map((subtitle) => ({
                    id: slugifyAnchor(subtitle.anchorId),
                    label: subtitle.header,
                })),
        }))
        .filter((section) => section.children.length > 0);

    if (!sections.length) {
        return null;
    }

    return (
        <div className="table-of-contents-block">
            <TableOfContents
                items={items}
                eyebrow={block.eyebrow || "Agenda / Table of contents"}
                title={block.title || "Table of contents"}
                titleId={`${blockId}-title`}
            />
        </div>
    );
};

export default TableOfContentsBlock;
